import $ from 'jquery';
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import dhtmlXTreeObject from '../../../dx/dxSource/components/dhtmlXTreeObject';

import {
    _getSearchInput,
    _getAlSelSearchInput, _dataFromMap,
} from "../comJs";
import unitCommon from "../../../jsCom/goAclDialog/components/unitCommon";
import GoTabUrl from "../goTabsUrl";


class UnitTab extends TabCell {

    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);
        let tabCellId="unit";
        this.tabIdName = tabCellId;
        this.dataFrom = _dataFromMap[tabCellId];
        this.tabLabel = _dataFromMap[tabCellId];
        this.dataFrom = "unit";
        this.dataFromLabel = "单位";
        this.active = false;
        //集团帐套节点 设置为跳过节点
        this.skipIds=["supperAccount"];
        this.hasSaveGroup = false;
        this.goTabs = goTabs;
        this.hasType=vueObj.hasType;
    }

    /**
     * 销毁tab对象
     */
    destructionTab() {
        //销毁表格
        if (this.alreadySelGrid != null && AssertUtils.isFunction(this.alreadySelGrid.destructor)) {
            this.alreadySelGrid.destructor();
            this.alreadySelGrid = null;
        }
        //销毁树
        if (this.unitTreeObj != null && AssertUtils.isFunction(this.unitTreeObj.destructor)) {
            this.unitTreeObj.destructor();
            this.unitTreeObj = null;
        }

        $("#" + this.tabId + "_body").html("");
        for (let c in this) {

            this[c] = null;
        }
    }

    /**
     * 获取左边容器的内容
     * @returns {string}
     */
    getLeftCellContent() {
        return `<div class="filter-bar clearfix"> 
              <div class="search-input pull-left">  
                 ${_getSearchInput(350, "请输入单位名称")}
              </div> 
            </div>
            <div class="depart-tree-div"> 
               <div id="${this.tabId}_tree"></div>
            </div>
           `;
    }

    /**
     * 获取右边容器的内容
     * @param panelHeight
     * @returns {string}
     */
    getRightCellContent(panelHeight) {
        let saveGroup = GoingUtils.parseBoolean(this.goTabs.options["saveGroup"]);
        return `<div>
            <div class="filter-bar clearfix"> 
                 <div class="pull-left" style="height: 30px;line-height: 30px;cursor: pointer;display:${saveGroup ? 'block' : 'none'}">【保存为组】</div>
               <div class="search-input pull-right" style="margin-right: 10px;">  
                   ${_getAlSelSearchInput(320, "请输入名称")}
                </div>
            </div>
             <div class="already-sel-user">
                  <div id="${
            this.tabId
            }_already_sel"  style="height: ${panelHeight - 40}px;"></div>
            </div>
         </div>`;
    }

    /**
     * 初始化单位树
     */
    initUnitTree() {
        let cellObj = this;
        let treeHeight = $("#" + this.tabId + "_tree").closest(".acl-cell-div").height();
        treeHeight = parseFloat(treeHeight + "") - 40 + "px";

        let unitTreeObj = new dhtmlXTreeObject(
            this.tabId + "_tree",
            "100%",
            treeHeight,
            0
        );
        //初始化树的点击事件
        unitCommon._initTreeSelEvent(cellObj, unitTreeObj);
        unitTreeObj.flushTreeByUrl({
            url: GoTabUrl.queryAllAccounts, backFun: function (treeObj) {
                //加载完数据后 再展开所有节点
                treeObj.openMaxLevel=2;
                unitTreeObj.openAllItems("0");
                treeObj.openMaxLevel=10;
                //根据初始化id集合 选中节点
                if (AssertUtils.isNotEmpty(cellObj.initIds)) {
                    cellObj.initIds.split(GoingUtils.relChart).forEach(function (id) {
                        if (AssertUtils.isNotEmpty(id)) {
                            cellObj.unitTreeObj.setCheck(id, true);
                        }
                    });
                }
            },
        });

        //设置树可以进行选择操作
        cellObj.itemConfig["selTreeNode"] = true;
        //注册树事件
        unitTreeObj.attachEvent("onClick", function (id) {
            if (cellObj.goTabs["count"] === 1) {
                //如果是单选 清空以前到数据
                let alreadyGrid = cellObj.alreadySelGrid;
                alreadyGrid.clearAll();
                //执行radio选择操作
                unitCommon._executeRadioSel(unitTreeObj, cellObj, id);
            } else {
                //执行checkbox选择操作
                unitCommon._executeCheckSel(unitTreeObj, cellObj, id);
            }
            return true;
        });
        this.unitTreeObj = unitTreeObj;
    }

    /**
     * 根据以前选中的数据 来初始化单位树的显示状态
     * @param ids
     * @param names
     * @private
     */
    _initDataFun(ids) {
        this.initIds = ids;
    }

    /**
     * 从其他tab里面复制数据 进入到 当前tab的表格中
     * @param rowId
     * @param orgGrid
     * @param dateForm
     */
    addAlreadGridFromOldGrid(rowId, orgGrid, dateFormLabel,dateFormId) {
        let cellObj = this;
        if (!AssertUtils.isNotNull(orgGrid)) {
            orgGrid = this.waitSelGrid;
        }
        let alreadyGrid = this.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            let dataJson = orgGrid.getRowRecord(rowId);
            //如果不存在 则进行增加 如果存在 则不进行增加
            if (alreadyGrid.getRowIndex(rowId) < 0) {
                alreadyGrid.addRow(rowId, [
                    "",
                    dataJson["realName"] + cellObj.appendAccountName(dataJson, cellObj),
                    dataJson["postName"],
                    dateFormLabel,
                    dateFormId
                ]);
            }
        }
    }

    /**
     * 添加已经选中的数据
     * @param nodeId
     */
    addRecordToAlreadyGrid(nodeId) {
        let alreadyGrid = this.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            let text = this.unitTreeObj.getItemText(nodeId);
            //如果不存在 则进行增加 如果存在 则不进行增加
            if (alreadyGrid.getRowIndex(nodeId) < 0) {
                this.currentAccountId = nodeId;
                alreadyGrid.addRow(nodeId, ["", text, "", "单位"]);
            }
        }
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        let cellObj = this;
        this.initUnitTree();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            //点击单位查询
            searchFun: function () {
                (cellObj).searchWaitForUser();
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        //初始化控件事件
        this.initCtlEvent();
    }



    /**
     * 查询待选择的数据
     */
    searchWaitForUser() {
        let searchText = $("#" + this.tabId + "_body").find(".search_userName_input").val();
        this.unitTreeObj.findItem(searchText);
    }

    //初始化控件事件
    initCtlEvent() {
        this.initIconBtnEvent(this.unitTreeObj);
        this.searchAlReadyRecord(this);
    }

    changeAccountEvent() {
    }

    removeSelectedRecord(rId) {
        this.unitTreeObj.setCheck(rId, false);
        this.unitTreeObj.clearSelection(rId);
    }

    allCheckBoxClick() {
    }
}

function initUnitTab(goTabs, vueObj) {
    let departTab = new UnitTab(vueObj, goTabs);
    goTabs.addTabToFactory("unit", departTab);
}

export default initUnitTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/unitTab.js